module.exports = __webpack_public_path__ + "static/media/playground-kids-run.2ab88898.mov";